(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ICalendarFeed',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.copy-to-clipboard').click(function copyToClipboard(e)
		{
			var textbox = $('#icalendarfeed-icalendar_feed_url')[0];

			e.preventDefault();

			textbox.focus();
			textbox.setSelectionRange(0, textbox.value.length);

			if (!document.execCommand('copy')) {
				textbox.setSelectionRange(0, 0);

				Adzuki.StatusMessage('Error', 'Error copying iCalendar feed URL to clipboard.');
				return;
			}

			textbox.setSelectionRange(0, 0);

			Adzuki.StatusMessage('Success', 'The iCalendar feed URL has been copied to your clipboard.');
		});
	};
}(jQuery, window.Adzuki || {}));
